import {
  EndPointsNames as EndPointsNamesEngine,
  Mocks,
} from '@smiles/core-defs';

export * from '@smiles/core-defs';

const endPointsName = ['ApiAccount', 'ApiPartner', 'ApiAirports'] as const;

export type EndPointsNames =
  | EndPointsNamesEngine
  | typeof endPointsName[number];

Mocks.getInstance().updateEndpoints(endPointsName);

export type BussinessErrorLocalType =
  | 'countryNotFound'
  | 'zipCodeNotFilled'
  | 'zipCodeNotExists';

export const REPO_API = 'https://smiles-sa.postman.co/workspace/';
